import React from "react";
import { useSelector } from "react-redux";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { convertTime, formatDateAndTime, formatDateTime } from "../common-data/Converts";

const ManualExtensionTable = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { manualExtensionData, manualExtensionDataLoading } = useSelector(
    (state) => state.plans
  );

  const isLoading = manualExtensionDataLoading;
  const tableData = manualExtensionData?.data || [];
  
  const paginationData = manualExtensionData?.pagination?.[0] || {};
  const pagination = [paginationData]; 


  const tableColumns = [
    { 
      dataField: "member_details", 
      text: "Member Details", 
      formatter: (_, row) => (
        <div>
          <div className="tb-data minWidth150 font-weight-bold">{row?.name || "N/A"}</div>
          <div className="tb-data minWidth150 text-muted">{row?.mobile || "N/A"}</div>
        </div>
      ), 
    },
    { 
      dataField: "gym_name", 
      text: "Gym Name", 
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "N/A"}</span>
      ), 
    },
    { 
      dataField: "extend_days", 
      text: "Extend Days", 
      formatter: (_, row) => (
        <button 
          className="extend-days-button"
          style={{
            backgroundColor: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "4px",
            padding: "4px 8px",
            fontSize: "12px",
            fontWeight: "bold"
          }}
        >
          {row?.extend_days || "N/A"}
        </button>
      ), 
    },
    { 
      dataField: "added_by", 
      text: "Added By", 
      formatter: (_, row) => (
        <div>
          <span className="tb-data minWidth150 font-weight-bold">{row?.added_by_name || "N/A"}</span>
        </div>
      ), 
    },
    { 
      dataField: "date_added", 
      text: "Date Added", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{formatDateTime(row?.date_added) || "-"}</span>
      ), 
    },
    { 
      dataField: "plan_name", 
      text: "Plan Name", 
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.plan_name || "N/A"}</span>
      ), 
    },
    { 
      dataField: "duration", 
      text: "Duration", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{row?.duration || "0"} days</span>
      ), 
    },
  ];

  if (isLoading) { 
    return <ReactVortoxSpinner />; 
  }

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable mt15">
      <PaymentLinkTable 
        tableData={tableData} 
        tableColumns={tableColumns} 
        tablePagination={pagination} 
        isPage={isPage} 
        setIsPage={setIsPage} 
        pageLimit={pageLimit} 
        setPageLimit={setPageLimit} 
      />
    </div>
  );
};

export default ManualExtensionTable;
